<div class="selected-round round-card flex-col content-between mt-10 w-90 margin-auto"
  [ngClass]="isMobile ? 'w-90 margin-auto' : 'w-full'">
  <div class="align-items-start content-between gap-20 mb-50" [ngClass]="isMobile ? 'flex-col' : 'flex-row'">
    <div class="flex-row gap-20">
      <img src="assets/list-icon.svg" alt="list-icon" class="icon" width="40px">
      <div class="flex-col">
        <p class="no-margin dark-blue">{{electionSelected + 1}} <sup
            style="top: -4px; left: -2px; font-size: 10px;">{{electionSelected === 0 ?
            'ère' : 'ème'}}</sup> élection</p>
        <p class="no-margin dark-blue bold">
          {{rounds[electionSelected].title}}
        </p>
      </div>
    </div>
    <button class="no-margin dark-blue bold candidate-button text-left">
      <img
        *ngIf="rounds[electionSelected].displayedQuestions[0].listImages[listSelected] != undefined && rounds[electionSelected].displayedQuestions[0].listImages[listSelected] !== ''"
        src="{{rounds[electionSelected].displayedQuestions[0].listImages[listSelected]}}" alt="list-icon" class="icon"
        width="40px">
      {{rounds[electionSelected].questions[0].answers[listSelected]}}
    </button>
  </div>
  <div class="">
    <div *ngFor="let candidate of displayedCandidates; let i = index;" class="candidate-card flex-col
          w-full content-between mb-10">
      <div class="flex-row gap-20 content-center w-full">
        <div class="flex-row gap-20 content-between align-items-center w-full">
          <div class="flex-row align-items-center gap-10">
            <p class="no-margin dark-blue bold text-lg">{{i + 1}}.</p>

            <img *ngIf="candidate.listImages[0] != undefined else samplePicture" src="{{candidate.listImages[0]}}"
              alt="list-icon" class="icon" width="40px">
            <ng-template #samplePicture>
              <img *ngIf="candidate.question.startsWith('M.')" src="assets/man-icon.svg" alt="man-icon" class="icon">
              <img *ngIf="candidate.question.startsWith('Mme')" src="assets/woman-icon.svg" alt="woman-icon"
                class="icon">
            </ng-template>
            <p *ngIf="candidate.links[0] == undefined || candidate.links[0] == null" class="no-margin dark-blue bold"
              [ngClass]="isMobile ? 'text-sm' : 'text-lg'"
              [style.text-decoration]="localAnswers[i] === 1 ? 'none' : 'line-through'">
              {{candidate.question}}
            </p>
            <a *ngIf="candidate.links[0] != undefined && candidate.links[0] != null" class="no-margin dark-blue bold"
              [ngClass]="isMobile ? 'text-sm' : 'text-lg'" href="{{candidate.links[0]}}" target="_blank"
              rel="noopener noreferrer" [style.text-decoration]="localAnswers[i] === 1 ? 'none' : 'line-through'">
              {{candidate.question}}
            </a>

          </div>
          <div style="display: flex; flex-direction: column; align-items: center;">

            <div [ngClass]="['checkbox' + ' checkbox-' + i]">
              <input type="checkbox" name="candidate-checkbox" class="candidate-checkbox pointer"
                [checked]="localAnswers[i] === 1" (change)="selectionHandler(i)">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex-col align-items-center mt-50 mb-30">
      <button *ngIf="!loading" [ngClass]="isVoteValid ? 'action-button' : 'action-button-disabled'"
        (click)="isVoteValid && locallyConfirmSelection()" [disabled]="loading">
        <span *ngIf="!loading">VALIDER MON CHOIX</span>
        <!-- <p-progressSpinner *ngIf="loading" 
          [style]="{'max-height': '30px', 'max-width': '30px'}" 
          strokeWidth="3" 
          animationDuration=".8s"
          styleClass="custom-spinner"></p-progressSpinner> -->
      </button>

      <button *ngIf="loading" class="action-button-disabled"
        [disabled]="loading">
        <span>TRAITEMENT EN COURS...</span>
      </button>
      <p class="dark-blue no-margin text-sm text-center pointer mt-20" (click)="setActiveList(-1)">Annuler</p>
    </div>
  </div>